/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from "react";
import { getBoostStripeAccountKey } from "@tomocredit/common-fe/utils";

export const PromoContext = React.createContext();

export const PromoProvider = ({ children }) => {
  const deadline = new Date("2024-06-01T07:00:00.000Z");
  const promoInfo = {
    deadline,
    text: "Limited Time Spring Special",
    showCountDown: Date.now() < deadline.getTime(),
  };

  // TODO: temporarily use this place to store stripeAccount. will remove once it is effective
  const stripeAccount = getBoostStripeAccountKey() === process.env.REACT_APP_STRIPE_V2_PUBLIC_KEY ? "BOOST_V2" : "BOOST";

  const contextValue = useMemo(
    () => ({ promoInfo, stripeAccount }),
    [promoInfo, stripeAccount],
  );

  return (
    <PromoContext.Provider value={contextValue}>
      {children}
    </PromoContext.Provider>
  );
};

export const withPromo = (Component) => (props) =>
  (
    <PromoContext.Consumer>
      {(context) => <Component {...props} themeContext={context} />}
    </PromoContext.Consumer>
  );
